import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserService } from '@app/core/services/user.service';

@Component({
  selector: 'app-auth-logout',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './auth-logout.component.html',
  styleUrl: './auth-logout.component.css'
})
export class AuthLogoutComponent {
  public countdown: number = 3;

  constructor(
    private readonly userService: UserService,
  ) {
    setTimeout(() => {
      this.userService.logout();
    }, 300)
  }


}
